<template>
  <div v-if="show" ref="dialog" class="dialog" @click.stop="close">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  const dialog = ref()

  defineProps({
    show: Boolean,
  })

  const emit = defineEmits(['close'])

  const close = (e: MouseEvent) => {
    if (e.target === dialog.value) {
      emit('close')
    }
  }
</script>

<style lang="stylus" scoped>
  .dialog
    top 0
    left 0
    position absolute
    height 100%
    width 100%
    min-width h5_main_min_width
</style>
